import Vue from 'vue';
import Ele from 'element-ui'
import App from './App.vue';
import router from './router'
import store from './store'
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'

import vuescroll from 'vuescroll';
import BaiduMap from 'vue-baidu-map'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式

import 'babel-polyfill'
Vue.use(Ele);

Vue.config.productionTip = true;

Vue.use(vuescroll, {
    ops: {
        rail: {
            opacity: '0',
            background: '#CCC',
            border: '0px solid #cecece',
            size: '5px',
            keepShow: false
        },
        bar: {
            onlyShowBarOnScroll: false,
            background: '#909399',
            keepShow: false,
            size: '5px',
            minSize: 0.2
        },
        scrollButton: {
            enable: false,
            background: '#909399'
        },
        scrollPanel: {
            easing: 'easeInQuad',
            speed: 800,
            scrollingX: false
        },
        vuescroll: {
            wheelScrollDuration: 0,
            wheelDirectionReverse: false
        }
    }, // 在这里设置全局默认配置
    name: 'myScroll' // 在这里自定义组件名字，默认是vueScroll
});

Vue.use(AlloyFingerPlugin, {
    AlloyFinger
});


Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: '2GnsAmvXS1gmwLqhBVWe9qOu'
})

Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999,
        navbar: false,
        title: false
        /*toolbar: {
    //zoomIn: 4,
    //zoomOut: 4,
    //oneToOne: 4,
    //reset: 4,
    prev: 1,
    play: {
    show: 4,
    size: 'large',
    },
    next: 1,
    //rotateLeft: 4,
    //rotateRight: 4,
    //flipHorizontal: 4,
    //flipVertical: 4,
    } */
    }
})

const requireComponent = require.context(
    // 其组件目录的相对路径
    './components/base',
    // 是否查询其子目录
    false,
    // 匹配基础组件文件名的正则表达式
    /ff\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName)

    // 获取和目录深度无关的文件名
    const componentName = fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '');
    // 全局注册组件
    Vue.component(
        componentName,
        // 如果这个组件选项是通过 `export default` 导出的，
        // 那么就会优先使用 `.default`，
        // 否则回退到使用模块的根。
        componentConfig.default || componentConfig
    )
});

const clickoutsideContext = '@@clickoutsideContext';
Vue.directive('Clickoutside', {
    bind(el, binding, vnode) {
        const documentHandler = (e) => {
            if (vnode.context && !el.contains(e.target)) {
                vnode.context[el[clickoutsideContext].methodName]();
            }
        };
        el[clickoutsideContext] = {
            documentHandler,
            methodName: binding.expression,
            arg: binding.arg || 'click',
        };
        document.addEventListener(el[clickoutsideContext].arg, documentHandler);
    },
    update(el, binding) {
        el[clickoutsideContext].methodName = binding.expression;
    },
    unbind(el) {
        document.removeEventListener(
            el[clickoutsideContext].arg,
            el[clickoutsideContext].documentHandler);
    }
});

NProgress.configure({ ease: 'ease', speed: 500 })

NProgress.start();
NProgress.done();

router.beforeEach((to, from, next) => {
    NProgress.start();

    let tctype = store.getters.tctype || 0;
    let tctitle = tctype == 2 ? '泰尔弗商学院' : tctype == 1 ? '戴尔特商学院' : '韬客学院-TOKCollege';
    let _title = (to.params.root == 'zx') ? '英国名校本硕连读项目' : tctitle;
    window.document.title = _title;

    let affdisplay = 'display:none !important;';

    if (to.params) {
        let root = to.params.root;

        if (((root == 'member') || (root == 'course') || (root == 'learn')) && (store.state.islogin == 0)) {
            next('/');
            return;
        }

        if (!((root == 'member') || (root == 'course') || (root == 'learn') || (root == 'zx'))) {
            affdisplay = 'display:block !important;';
        }

        if (root == "home" || !root) {
            store.commit('SET_TOPNAV', 1);
        }
        else if (root == "college") {
            store.commit('SET_TOPNAV', 2);
        }
        else if (root == "news") {
            store.commit('SET_TOPNAV', 3);
        }
        else if (root == "contact") {
            store.commit('SET_TOPNAV', 4);
        }
        else if (root == "voice") {
            store.commit('SET_TOPNAV', 5);
        }
        else if (root == "student") {
            store.commit('SET_TOPNAV', 6);
        }
        else if (root == "course") {
            store.commit('SET_TOPNAV', 9);
        }
        else if (root == "learn") {
            store.commit('SET_TOPNAV', 900);
        }
        else {
            store.commit('SET_TOPNAV', 0);
        }
    }

    if (document.querySelector('#newBridge')) {
        document.querySelector('#newBridge').style.cssText = affdisplay;
    }
    else {
        let affinterval = window.setInterval(function () {
            if (document.querySelector('#newBridge')) {
                document.querySelector('#newBridge').style.cssText = affdisplay;
                window.clearInterval(affinterval);
            }
        }, 50);
    }

    next();
});

Vue.directive('title', {
    inserted: function (el) {
        let tctype = store.getters.tctype || 0;
        let tctitle = tctype == 2 ? '泰尔弗商学院' : tctype == 1 ? '戴尔特商学院' : '韬客学院-TOKCollege';
        document.title = el.dataset.title || tctitle;
    }
})

router.afterEach(() => {
    NProgress.done();
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
